import { itemChangeTitle } from "helpers/bid";
import { getShortAddress } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { itemChangePointStatuses } from "helpers/enums";
import { enumLabel } from "helpers/system";
import Tooltip from "rc-tooltip";
import React from "react";

const PlanItem = (props) => {
    const { i, item, switchComponent, bidId, items, hasParallelBidId, bid, itemChangesHistory } = props;
    const {
        id,
        shiftCar,
        shiftDriver,
        shiftSecondaryDriver,
        shiftTrailer,
        mapObject,
        planEnterDateOffset,
        status,
        manualStartAt,
        manualEndAt,
        autoEnteredAt,
        autoLeftAt,
    } = item;
    return (
        <tr
            onClick={() =>
                switchComponent("planShow", { id, bidId, items, item, hasParallelBidId, itemChangesHistory })
            }
        >
            <td>{i + 1}</td>
            <td>{itemChangeTitle(shiftCar, shiftDriver, shiftSecondaryDriver, shiftTrailer)}</td>
            <td>{dateTimeToView(planEnterDateOffset)}</td>
            <td>{dateTimeToView(autoEnteredAt)}</td>
            <td>{dateTimeToView(autoLeftAt)}</td>
            <td>{enumLabel(itemChangePointStatuses, status)}</td>
            <td>
                {getShortAddress(mapObject).map((addr, i) =>
                    i > 0 ? (
                        <small key={i} className="text-muted">
                            {addr}
                        </small>
                    ) : (
                        <p key={i} className="mb-0">
                            {addr}
                        </p>
                    ),
                )}
            </td>
            <td>
                <Tooltip placement="left" overlay="Установить ручные даты">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-xs mr-2"
                        onClick={(e) => {
                            e.stopPropagation();
                            props.switchComponent("manualDates", {
                                item: { id, bidId, manualStartAt, manualEndAt, hasParallelBidId },
                            });
                        }}
                    >
                        <i className="icon-uEA54-checkmark" />
                    </button>
                </Tooltip>
                <button
                    type="button"
                    className="btn btn-danger btn-xs"
                    onClick={(e) => {
                        e.stopPropagation();
                        props.switchComponent("confirm", {
                            params: { id, bidId, itemType: "plan" },
                            hasParallelBidId,
                            shiftCar,
                            bid,
                        });
                    }}
                >
                    <i className="icon-uEA31-trash" />
                </button>
            </td>
        </tr>
    );
};

export default PlanItem;
